const RESEARCH_EXPERIMENT_KEY = 'onboarding.hasSeenResearchExperiment';

const set = () => localStorage.setItem(RESEARCH_EXPERIMENT_KEY, 'true');

const get = () => {
  return localStorage.getItem(RESEARCH_EXPERIMENT_KEY);
};

const researchExperimentStorage = {
  get,
  set,
};

export default researchExperimentStorage;
